import { useQuery } from '@tanstack/react-query';
import { canaryKeys } from '../keys';
import { getMe } from './api';

/** Who the caller is in the canary. The server checks again on every request;
 *  this only decides what to show. */
export function useCanaryMe() {
  return useQuery({ queryKey: canaryKeys.me(), queryFn: getMe, staleTime: 30_000 });
}
